import { toast } from "react-hot-toast";

// export const BASEURL = "http://localhost:4000";
export const BASEURL = "https://premint-backend.herokuapp.com";

export const successToast = (message) => toast.success(message);
export const errorToast = (message) => toast.error(message);
